import { ResponseError } from 'services/api/base';
import { useGetWindxAboutTabsQuery } from 'services/api/windx';
import { useHandleRequestErrors } from 'utils/hooks';

export default function useInstructionTabs() {
  const { data, error, isLoading } = useGetWindxAboutTabsQuery();

  useHandleRequestErrors(error as ResponseError);

  return {
    instructionTabs: data,
    isLoading,
  };
}
